// import generatePDF from "react-to-pdf";

// export function CommonPdf(pdfRef,filename){

//     const options = {
//         filename: filename,
//         page: {
//           margin: 20
//         }
//     };

//     if (!pdfRef.current) {
//         console.error("Unable to get the target element.");
//         return;
//     }

//     const tempPdfRef = pdfRef;        
//     const logoImg = tempPdfRef.current.querySelector("img");
//     const originalDisplay = logoImg?.style.display;
//     if (logoImg) {
//         logoImg.style.display = "block";
//     }

//     generatePDF(tempPdfRef,options);

//     if (logoImg) {
//         logoImg.style.display = originalDisplay || "none";
//     }
// }

import generatePDF from "react-to-pdf";

export function CommonPdf(pdfRef, filename) {

    const options = {
        filename: filename,
        page: {
            margin: 20
        }
    };

    if (!pdfRef.current) {
        console.error("Unable to get the target element.");
        return;
    }

    const tempPdfRef = pdfRef;

    // 🔥 Show PDF-only elements
    const pdfOnlyElements = tempPdfRef.current.querySelectorAll(".pdf-only");
    pdfOnlyElements.forEach(el => el.style.display = "block");

    // 🔥 Show logo
    const logoImg = tempPdfRef.current.querySelector("img");
    const originalDisplay = logoImg?.style.display;
    if (logoImg) {
        logoImg.style.display = "block";
    }

    generatePDF(tempPdfRef, options);

    // 🔥 Hide again after PDF generation
    pdfOnlyElements.forEach(el => el.style.display = "none");

    if (logoImg) {
        logoImg.style.display = originalDisplay || "none";
    }
}